import React, { useCallback, useEffect, useState } from "react";
import { partnerApi } from "../services/api";

const STATUS_OPTIONS = ["approved", "awaiting", "rejected", "draft"];

export default function PartnerCars() {
  const [cars, setCars] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [savingId, setSavingId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await partnerApi.cars(status || undefined);
      setCars(res.data || []);
    } catch (err) {
      setError(err.message || "Failed to load cars");
    } finally {
      setLoading(false);
    }
  }, [status]);

  useEffect(() => {
    load();
  }, [load]);

  const updateStatus = async (car, nextStatus) => {
    setSavingId(car._id);
    try {
      await partnerApi.updateCar(car._id, { status: nextStatus });
      await load();
    } catch (err) {
      setError(err.message || "Update failed");
    } finally {
      setSavingId(null);
    }
  };

  return (
    <div>
      <div className="admin-toolbar">
        <h2>Assigned Cars</h2>
        <select value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">All statuses</option>
          {STATUS_OPTIONS.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      {error ? <div className="admin-error">{error}</div> : null}
      {loading ? (
        <div className="admin-loading">Loading cars…</div>
      ) : cars.length === 0 ? (
        <p>No cars found for your assigned sub registers.</p>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Car</th>
                <th>Sub Register</th>
                <th>Price</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {cars.map((car) => (
                <tr key={car._id}>
                  <td>
                    {car.year} {car.brand?.name} {car.model?.name}
                  </td>
                  <td>{car.sub_register?.name || "—"}</td>
                  <td>₹{Number(car.price || 0).toLocaleString()}</td>
                  <td>{car.status}</td>
                  <td>
                    <select
                      value={car.status}
                      disabled={savingId === car._id}
                      onChange={(e) => updateStatus(car, e.target.value)}
                    >
                      {STATUS_OPTIONS.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
